import React, { useCallback, useState } from "react";
import { MetricDetails } from "components/metrics";
import { Icon } from "components/common";
const iconMapping = {
  timer: "schedule",
  histogram: "signal_cellular_alt",
  meter: "play_circle",
  gauge: "speed",
  counter: "circle",
  unknown: "help"
};
const _formatIcon = (type) => {
  var _a;
  return (_a = iconMapping[type]) != null ? _a : iconMapping.unknown;
};
const _formatName = (metricName, namespace) => {
  const split = metricName.split(namespace);
  const unqualifiedMetricName = split.slice(1).join(namespace);
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: "prefix" }, namespace), unqualifiedMetricName);
};
const Metric = ({ metric, namespace, nodeId }) => {
  const [expanded, setExpanded] = useState(false);
  const _showDetails = useCallback((e) => {
    e.preventDefault();
    setExpanded((_expanded) => !_expanded);
  }, []);
  const details = expanded ? /* @__PURE__ */ React.createElement(MetricDetails, { nodeId, metric }) : null;
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("div", { className: "name" }, /* @__PURE__ */ React.createElement(Icon, { name: _formatIcon(metric.type) }), " ", /* @__PURE__ */ React.createElement("a", { className: "open", href: "#", onClick: _showDetails }, _formatName(metric.full_name, namespace))), details);
};
export default Metric;
